import { IDeleteOptions, TDefinitionKey, TJsonQueryValue } from './definitionFactory';
import { IThunkActionCreator } from '../../types/thunk';
import { clearJsonQueryAction } from '../filters';
import { getOffersData } from '../offersData';
import { putDefaultRegion, updateTags } from './tags';
import { selectCanUseHiddenBase } from '../../selectors/user';

export function onDeleteAction(
  value: TJsonQueryValue,
  key: TDefinitionKey,
  options: IDeleteOptions,
): IThunkActionCreator {
  return (dispatch, getState) => {
    dispatch(clearJsonQueryAction(key, value));
    dispatch(updateTags());
    dispatch(putDefaultRegion());
    if (!options.skipUpdateOffersCount) {
      const state = getState();
      const canUseHiddenBase = selectCanUseHiddenBase(state);
      dispatch(getOffersData({ canUseHiddenBase }));
    }
  };
}
